import { Injectable } from '@angular/core';
import { makeStateKey, StateKey, TransferState } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { ObservableLoader } from './observable.loader';

@Injectable()
export class ObservableBrowserLoader extends ObservableLoader {
  constructor(private readonly transferState: TransferState) {
    super();
  }

  public override load<T>(key: string, observable: () => Observable<T>): Observable<T> {
    const stateKey: StateKey<any> = makeStateKey<any>(key);

    if (this.transferState.hasKey(stateKey)) {
      const data = this.transferState.get(stateKey, null);

      return new Observable<T>((observer) => {
        observer.next(data);
        observer.complete();
      });
    }

    return observable();
  }
}
